import { ContentBlock } from "@/types";
import { createSecurityServiceContent } from "@/content/services/service-content-helpers";

export const content: ContentBlock[] = [
  ...createSecurityServiceContent({
    serviceName: "CCTV installation and maintenance",
    summary:
      "CCTV work starts with coverage, not just camera count. Ozy Wide Group plans camera locations around entries, driveways, counters, storage areas, perimeter lines and the lighting conditions that affect footage quality. The goal is a practical system that helps identify activity clearly and can be checked easily when something happens.",
    suitedTo: [
      "homes",
      "retail shops",
      "offices",
      "warehouses",
      "strata common areas",
      "construction sites",
    ],
    includes: [
      "camera placement advice",
      "CCTV installation",
      "recorder setup",
      "remote viewing support",
      "fault checks and maintenance",
    ],
    notes: [
      "camera angles",
      "night lighting",
      "network access",
      "privacy boundaries",
      "cable routes",
      "where footage will be reviewed",
    ],
    process: [
      "Walk through the property or plans to identify the areas that need coverage and the places that should be avoided for privacy.",
      "Select camera positions, recorder location and cabling paths before installation starts.",
      "Set up viewing access and explain basic operation so the system can be used confidently after handover.",
    ],
    faq: [
      "Camera type depends on distance, lighting, field of view and whether the area is indoors, outdoors or exposed.",
      "Existing systems can often be inspected, repaired or upgraded without replacing every component.",
      "Remote viewing needs stable internet access and suitable user permissions for the people who need access.",
    ],
  }),
];
